import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from 'react-router-dom';
import { Typography } from "@material-ui/core";
import { Helmet } from 'react-helmet-async'

import './announcements.css'

import { FnsHeader } from '../../common/fns-header'

interface AnnounceInfo {
  announcementText: string;
  categoryName: string;
  ctaButton: CtaButton;
  displayBegin: Date;
  title: string;
}

interface CtaButton {
  url: string;
  label: string;
  target: string;
}

interface AnnouncementPathParam {
  id: string;
}

interface FnsError {
  errorCode: string;
  errorMessage: string;
}

function dateFormat(date: Date): string {
  const d = new Date(date)
  const year = d.getFullYear()
  const month = d.getMonth() + 1
  const day = d.getDate()


  return year + '.' + month + '.' + day
}

export const Announcements = () => {
  const [announcement, setAnnouncement] = useState<AnnounceInfo>();
  const [error, setError] = useState<FnsError>();
  const id = useParams<AnnouncementPathParam>().id;

  useEffect(() => {
    axios.get("api/v1/sp/announcements/" + id)
      .then((result) => setAnnouncement(result?.data))
      .catch((error) => setError(error));
  }, [id]);

  return (
    <div className="topics-article pg-article">
      <Helmet title="お知らせ | Family Works" />
      <FnsHeader />
      <main className="wrapper">
        <section className="announce__section">
          {announcement && <>
            <div>
              <span className="announce__category">{announcement.categoryName}</span>
              <span className="announce__date">{dateFormat(announcement.displayBegin)}</span>
            </div>
            <p className="secArticle__title">{announcement.title}</p>
            <p className="secArticle__txt">
              {announcement.announcementText.split("\n").map((item) => <span key={item} > {item} < br /></span>)}
            </p>
            {announcement.ctaButton && <a className="announce__cta" href={announcement.ctaButton.url}>詳細はこちら</a>}
          </>
          }

        </section>
        {
          error &&
          <Typography variant="body1">{error.errorMessage}</Typography>
        }
      </main>
    </div >
  )
}